<section>
  <!-- BACK BUTTON -->
  <rappider-button *ngIf="displayBackButton"
                   [text]="toolbarConfig.text | translate"
                   [icon]="toolbarConfig.icon"
                   (click)="onToolbarBackButtonClick()"></rappider-button>
</section>
